var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "editor-controls" }, [
    _c(
      "div",
      { staticClass: "controls" },
      [
        _c(
          "ui-button",
          {
            attrs: { "svg-icon": "", tooltip: "Mark start" },
            on: {
              click: function ($event) {
                return _vm.$emit("markIn")
              },
            },
          },
          [_c("path", { attrs: { d: "M 12 0 l 0 8 -4 4 4 4 0 8" } })]
        ),
        _vm._v(" "),
        _c(
          "ui-button",
          {
            attrs: { "svg-icon": "", tooltip: "Go to start" },
            on: {
              click: function ($event) {
                return _vm.$emit("goToIn")
              },
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M 6 0 l 0 8 -4 4 4 4 0 8 M 7 12 l 12 10 0 -20 -12 10",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("ui-button", {
          attrs: { icon: "fal fa-step-backward", tooltip: "Step backward" },
          on: {
            click: function ($event) {
              return _vm.$emit("stepBackward")
            },
          },
        }),
        _vm._v(" "),
        _c("ui-button", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isPlaying,
              expression: "!isPlaying",
            },
          ],
          attrs: { icon: "fal fa-play", tooltip: "Play" },
          on: {
            click: function ($event) {
              return _vm.$emit("play")
            },
          },
        }),
        _vm._v(" "),
        _c("ui-button", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isPlaying,
              expression: "isPlaying",
            },
          ],
          attrs: { icon: "fal fa-pause", tooltip: "Pause" },
          on: {
            click: function ($event) {
              return _vm.$emit("pause")
            },
          },
        }),
        _vm._v(" "),
        _c("ui-button", {
          attrs: { icon: "fal fa-step-forward", tooltip: "Step forward" },
          on: {
            click: function ($event) {
              return _vm.$emit("stepForward")
            },
          },
        }),
        _vm._v(" "),
        _c(
          "ui-button",
          {
            attrs: { "svg-icon": "", tooltip: "Go to end" },
            on: {
              click: function ($event) {
                return _vm.$emit("goToOut")
              },
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M 17 0 l 0 8 4 4 -4 4 0 8 M 16 12 l -12 10 0 -20 12 10",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "ui-button",
          {
            attrs: { "svg-icon": "", tooltip: "Mark end" },
            on: {
              click: function ($event) {
                return _vm.$emit("markOut")
              },
            },
          },
          [_c("path", { attrs: { d: "M 12 0 l 0 8 4 4 -4 4 0 8" } })]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }